const onImageError = (
  e: React.SyntheticEvent<HTMLImageElement, Event>,
  image: string,
) => {
  return e.currentTarget.setAttribute('src', image);
};

export default onImageError;
